// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"39be0c9d","637":"aab6ff71"}[chunkId] + ".chunk.js";
};